import { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { CloseIcon } from '../../../misc/icons/Icons';

const ModalWrapper = ({
	children, isModalOpen, setIsModalOpen, showCloseIcon = false, maxWidth = 'max-w-lg', fullSize = false,
}) => {
	const closeModal = () => {
		setIsModalOpen(false);
	};

	return (
		<Transition appear show={isModalOpen} as={Fragment}>
			<Dialog
				as="div"
				className="fixed inset-0 z-50 overflow-y-auto"
				onClose={closeModal}
			>
				<div className="min-h-screen px-4 text-center">
					<Transition.Child
						as={Fragment}
						enter="ease-out duration-300"
						enterFrom="opacity-0"
						enterTo="opacity-100"
						leave="ease-in duration-200"
						leaveFrom="opacity-100"
						leaveTo="opacity-0"
					>
						<Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />
					</Transition.Child>

					{/* This element is to trick the browser into centering the modal contents. */}
					<span
						className="inline-block h-screen align-middle"
						aria-hidden="true"
					>
						&#8203;
					</span>
					<Transition.Child
						as={Fragment}
						enter="ease-out duration-300"
						enterFrom="opacity-0 scale-95"
						enterTo="opacity-100 scale-100"
						leave="ease-in duration-200"
						leaveFrom="opacity-100 scale-100"
						leaveTo="opacity-0 scale-95"
					>
						<div className={`inline-block w-full ${maxWidth} pt-6 px-5 pb-0 my-8 overflow-hidden text-left align-middle transition-all transform bg-white rounded-sm shadow-2xl`} style={fullSize ? { height: '90vh', width: '100vw' } : null}>
							{showCloseIcon && (
								<div className="absolute top-0 right-0 pt-1 pr-1">
									<button type="button" onClick={closeModal} className="p-3 transition duration-150 ease-in-out text-oly-blue-dark focus:outline-none" aria-labelledby="close">
										<CloseIcon className="w-6 h-6" />
									</button>
								</div>
							)}
							{children}
						</div>
					</Transition.Child>
				</div>
			</Dialog>
		</Transition>
	);
};

export default ModalWrapper;
